import axiosInstance from '../axiosInterceptor/axiosInstance'

const postPlayerMatch = async ({ orgId, gameId, gameTeamPlayerId, playerId }) => {
  const url = `v1/orgs/${orgId}/stats/games/${gameId}/team-players/${gameTeamPlayerId}/link`
  const response = await axiosInstance.post(url, { playerId })
  return response?.data
}

export default postPlayerMatch
